import { TFunction } from 'i18next';
import { ControlIcon, ExpandIcon, GrowthIcon } from '@/shared/ui';

export const getImpactsList = (t: TFunction) => {
  const impactsListData = t('productPages.locals.impactsList', {
    returnObjects: true,
  }) as Array<{ title: string; description: string }>;

  return impactsListData.map((item, index) => ({
    ...item,
    Icon: [ExpandIcon, ControlIcon, GrowthIcon][index]!,
  }));
};
